import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }
  h1,h2,h3,h4,h5,h6{
    padding: 0;
    margin: 0;
  }
  h1,h2,h3 {
    font-family: "Barlow", sans-serif;
    font-weight: 500;
  }
  h4,h5,h6 {
    font-family: "Barlow", sans-serif;
    font-weight: 400;
  }
  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    margin: 0;
    padding: 0;
    font-family: "Open Sans", sans-serif;
    transition: all 0.25s linear;
  }
  .button-dark-light, .button-dark-light a:focus{
    color:  ${({ theme }) => theme.text} !important;
  }
  .modal-content{
    background: ${({ theme }) => theme.body};
  }
  .user-page{
    color: ${({ theme }) => theme.text};
    border: 1px solid ${({ theme }) => theme.toggleBorder};
  }
  .apexcharts-legend-text{
    color: ${({ theme }) => theme.text} !important;
  }
  .react-resizable-handle::after{
    border-right: 2px solid ${({ theme }) => theme.text} !important;
    border-bottom: 2px solid ${({ theme }) => theme.text} !important;
  }
  .content-login, .content-home{
    background-color: ${({ theme }) => theme.body.slice(0, -1)}, 0.8);
  }
  .form-login input{
    border-bottom: solid 1px ${({ theme }) => theme.text};
    color: ${({ theme }) => theme.text};
  } 
  .form-login input:-webkit-autofill, .form-login input:-webkit-autofill:hover, .form-login input:-webkit-autofill:focus,.form-login input:-webkit-autofill:active {
    -webkit-text-fill-color: ${({ theme }) => theme.text};
  }
  .form-login input::placeholder {
    color: ${({ theme }) => theme.secondText};
  }
  .grid-div .react-grid-item {
    background-color: ${({ theme }) => theme.secondaryBody};
  }

  .button-login, .button-logout, .button-my-pages {
    color: ${({ theme }) => theme.text};
  }

  .apexcharts-data-labels text{
    fill: ${({ theme }) => theme.text} !important;
  }

  .apexcharts-xaxis-texts-g text{
    fill: ${({ theme }) => theme.text} !important;
  }

  .apexcharts-yaxis-texts-g text{
    fill: ${({ theme }) => theme.text} !important;
  }
  .button-filter{
    color: ${({ theme }) => theme.text} !important;
  }
  .add-new-page{
      background-color: ${({ theme }) => theme.body.slice(0, -1)}, 1);
  }
  .users-page{
      background-color: ${({ theme }) => theme.body.slice(0, -1)}, 0.6);
  }
  #tooltip-top > .tooltip-inner {
    color: ${({ theme }) => theme.body};
    background-color: ${({ theme }) => theme.text} !important;
    max-width: 600px !important;
  }

  #tableDetailsNotStarted{
    color: ${({ theme }) => theme.text} !important;
  }

  .text_theme{
    color: ${({ theme }) => theme.text} !important;
  }

  #header-modal button{
    filter: ${({ theme }) => theme.filter} !important;
  }

  #modal-details .card-body{
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text} !important;
  }
`;